import gsap from "gsap";
import { Container, Sprite, TextStyle, Text } from "pixi.js";
export default class OptionBtn extends Container {
  constructor(picto, label) {
    super();
    this.onDown = this.onDown.bind(this);
    this.onUp = this.onUp.bind(this);
    this.onOut = this.onOut.bind(this);
    this.btn = new Sprite(picto);
    this.btn.anchor.set(.5);
    this.btn.interactive = true;
    this.btn.buttonMode = true;
    this.btn.on('pointerdown', this.onDown);
    this.btn.on('pointerup', this.onUp);
    this.btn.on('pointerupoutside', this.onOut);
    this.addChild(this.btn);
    if (label) {
      const textStyle = new TextStyle({
        fontFamily: 'Anja Eliane accent',
        fontSize: 40,
        align: "left",
        fill: 0xffffff,
        stroke: '#222222',
        strokeThickness: 5
      });
      this._text = new Text(label, textStyle);
      this._text.anchor.y = .5;
      this._text.x = 50;
      this.btn.addChild(this._text);
    }
  }
  onDown(event) {
    if (!this._down) {
      this._down = true;
      gsap.to(this.btn.scale, {
        duration: .2,
        x: .9,
        y: .9
      });
    }
  }
  onUp(event) {
    if (this._down) {
      gsap.to(this.btn.scale, {
        duration: .2,
        x: 1,
        y: 1
      });
      this._callBack && this._callBack();
    }
    this._down = false;
  }
  onOut(event) {
    this._down = false;
    gsap.to(this.btn.scale, {
      duration: .2,
      x: 1,
      y: 1
    });
  }
  set texture(val) {
    this.btn.texture = val;
  }
  set click(callBack) {
    this._callBack = callBack;
  }
}
